import React, { Fragment } from 'react'
import styled from 'styled-components'

import breakpoints from '../../../constants/breakpoints'
// import Container from '../../../components/Layout/Container'
// import i18n from '../../../i18n'
import overview from './footer'
import logo from '../../../assets/logo_nhg.svg'

const Footer: React.FC = () => (
  <Fragment>
    {/* <TopFooter>
      <Container>
        <Section>
          <h3>{i18n.t('overview.footer.moreInformation')}</h3>

          <Blocks>
            {overview.content.map(block => (
              <Block key={block.title}>
                <h2>{block.title}</h2>
                <p>{block.text}</p>
                <Link to={block.link}>{i18n.t('overview.footer.readMore')}</Link>
              </Block>
            ))}
          </Blocks>

          <InfoLinks>
            {overview.infoLinks.map(link => (
              <Link key={link.title} to={link.link}>
                {link.title}
              </Link>
            ))}
          </InfoLinks>
        </Section>
      </Container>
    </TopFooter> */}

    <FooterContentInfo>
      <BrandBar>
        <DarkBlue />
        <Blue />
        <Green />
        <Yellow />
        <DarkGreen />
      </BrandBar>

      <Copyright>
        <p>{overview.copyright.description}</p>
        <Links>
          {overview.copyright.links.map(link => (
            <FooterLink key={link.title} href={link.link}>
              {link.title}
            </FooterLink>
          ))}
        </Links>
      </Copyright>

      <FooterLogo>
        <a href="https://www.nhg.org/">
          <img src={logo} width="92" height="55" alt="NHG logo" />
        </a>
      </FooterLogo>
    </FooterContentInfo>
  </Fragment>
)

// const Blocks = styled.div`
//   display: grid;
//   grid-template-columns: repeat(1, 1fr);
//   grid-auto-rows: 1fr;
//   grid-column-gap: 30px;
//   grid-row-gap: 30px;

//   @media (min-width: ${breakpoints.md}) {
//     grid-template-columns: repeat(2, 1fr);
//   }
// `

// const Block = styled.div`
//   max-width: 425px;

//   & h2 {
//     font-size: 1.5rem;
//     margin-bottom: 6px;
//     margin-top: 0;
//   }
// `

// const InfoLinks = styled.div`
//   margin-top: 45px;

//   & a {
//     margin-right: 55px;
//   }
// `

// const Section = styled.div`
//   box-sizing: border-box;
//   color: white;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   padding: 90px 0;

//   & a {
//     color: white;
//     text-decoration: none;

//     &:hover {
//       text-decoration: underline;
//     }
//   }

//   & h3 {
//     margin-bottom: 54px;
//     margin-top: 0;
//   }
// `

// const TopFooter = styled.div`
//   background-color: ${({ theme }) => theme.blue};
// `

const FooterContentInfo = styled.div`
  position: relative;
  padding: 15px;

  @media (min-width: ${breakpoints.md}) {
    padding: 20px;
  }
`

const BrandBar = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  margin-bottom: 25px;
  margin-top: 25px;

  @media (min-width: ${breakpoints.md}) {
    justify-content: flex-start;
  }

  & span {
    height: 3px;
    width: 22px;
  }
`

const DarkBlue = styled.span`
  background-color: #6b868d;
`

const Blue = styled.span`
  background-color: #97c0d2;
`

const Green = styled.span`
  background-color: #85af81;
`

const Yellow = styled.span`
  background-color: #ecbf38;
`

const DarkGreen = styled.span`
  background-color: #4f987a;
`

const Copyright = styled.div`
  font-size: 0.9rem;
  max-width: 500px;
  margin: 0 auto;

  & p {
    text-align: center;
    margin: 0;
  }

  @media (min-width: ${breakpoints.md}) {
    display: inline-block;
    & p {
      text-align: left;
    }
  }

  @media (min-width: ${breakpoints.lg}) {
    max-width: 740px;
  }
`

const Links = styled.div`
  margin: 15px 0;
  text-align: center;

  @media (min-width: ${breakpoints.md}) {
    text-align: left;
  }
`

const FooterLink = styled.a`
  color: ${({ theme }) => theme.warmGrey};
  text-decoration: none;
  margin-right: 12px;

  &:hover {
    text-decoration: underline;
  }
`

const FooterLogo = styled.div`
  text-align: center;

  @media (min-width: ${breakpoints.md}) {
    position: absolute;
    right: 15px;
    bottom: 23px;
  }

  @media (min-width: ${breakpoints.lg}) {
    right: 30px;
  }
`

export default Footer
